import React from "react";
import PropTypes from "prop-types";
import {useTranslation} from "react-i18next";
import {priceToString} from "core/utils/priceUtils";

const BsFormPriceInfoField = (props) => {
    const {t} = useTranslation();

    let valueDecoration = 'bs-form__info-value';
    switch (props.valueDecoration) {
        case 'capitalize':
            valueDecoration += ' bs-form__info-value-capitalize'
            break;
    }

    if (props.onClick) {
        valueDecoration += ' bs-form__info-value-active'
    }

    const value = priceToString(props.value, props.currency);

    return (
        <div className="bs-form__info">
            <div className="bs-form__info-label">
                {t(props.label)}
            </div>
            <div className={valueDecoration} onClick={props.onClick}>
                {(props.translate ? t(value) : value)}
            </div>
        </div>
    )
}

BsFormPriceInfoField.propTypes = {
    label: PropTypes.string,
    value: PropTypes.string,
    currency: PropTypes.string,
    translate: PropTypes.bool,
    valueDecoration: PropTypes.string
};

export default BsFormPriceInfoField;